var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page d-flex flex-column align-items-center justify-content-center pa-10"},[_c('h1',[_vm._v(" "+_vm._s(_vm.$t('general.404.title'))+" ")]),_c('y-button',{attrs:{"tag":"router-link","to":"/","color":"font","size":"small"}},[_vm._v(" "+_vm._s(_vm.$t('general.404.back_to_home'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }